import * as Routes from '@/modules/routes';
import React, { useMemo } from 'react';
import { IStudentRow } from '../../types';
import { columnHelper } from '../../variables';
import useGradesTableStore from '../../store/useGradesTableStore';
import useProgramAccess from '../../hooks/queries/useProgramAccess';
import useGames from '../../hooks/queries/exerciseResults/useGames';
import StateCapitalsGradeCell, { STATE_CAPITALS_GAME } from '../Cells/GradeCells/StateCapitalsGradeCell';
import { HeaderCell } from '../Cells';

const useStateCapitalsColumn = () => {
  const { data } = useProgramAccess();
  const { data: exerciseResults } = useGames();
  const programId = useGradesTableStore(state => state.programId);
  const classroom = useGradesTableStore(state => state.classroom);

  return useMemo(() => {
    if (!data.includes(programId)) return [];

    const accessor = (row: IStudentRow) => row.student.id;

    return ([
      columnHelper.accessor(accessor, {
        header: () => (
          <HeaderCell title="State Capitals Game" maxScore={STATE_CAPITALS_GAME.max_score}>
            <HeaderCell.SyncGradesButton
              exerciseType="game"
              exerciseResults={exerciseResults}
              link={Routes.send_game_scores_shared_program_game_path(
                STATE_CAPITALS_GAME.id, classroom.id,
                { classroom_id: classroom.id,
                  program_id: programId },
              )}
            />
          </HeaderCell>
        ),
        id: 'state-capitals-game',
        cell: info => <StateCapitalsGradeCell studentId={info.getValue()} />,
      }),
    ]);
  }, [classroom?.id, data.length, exerciseResults, programId]);
};

export default useStateCapitalsColumn;
